export const FormatterOptions = [
  'Full',
  'Compact',
  'Millions',
  'Thousands',
] as const
export type FormatterOption = (typeof FormatterOptions)[number]

export const USDOnlyFormatterOptions: FormatterOption[] = [
  'Millions',
  'Thousands',
] as const

export type QFManagerContextType = {
  currencyOptions: string[]
  setCurrencyOptions: (options: string[], selectedCurrency?: string) => void
  resetCurrencyOptions: () => void
  selectedCurrency: string
  setSelectedCurrency: (currency: string) => void
  cycleSelectedCurrency: (direction: 'forward' | 'reverse') => void
  selectedFormatter: FormatterOption
  setSelectedFormatter: (formatter: FormatterOption) => void
  cycleSelectedFormatter: (direction: 'forward' | 'reverse') => void
}

export type CycleDirection = 'forward' | 'reverse'
